import { css } from "styled-components";
import { ALIGNS } from "../consts";

var resolvePopoverHorizontal = function resolvePopoverHorizontal(_ref) {
  var anchor = _ref.anchor,
      containerLeft = _ref.containerLeft,
      containerWidth = _ref.containerWidth,
      popoverWidth = _ref.popoverWidth,
      theme = _ref.theme;

  if (anchor === ALIGNS.START) {
    return css(["left:", "px;"], theme.rtl ? Math.floor(containerLeft + containerWidth - popoverWidth) : Math.floor(containerLeft));
  }

  if (anchor === ALIGNS.END) {
    return css(["left:", "px;"], Math.floor(containerLeft + containerWidth - popoverWidth));
  }

  return null;
};

export default resolvePopoverHorizontal;